// Initialize Swiper
import Isotope from "isotope-layout";
import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
new Swiper('.hero-swiper', {
    modules: [Navigation, Pagination],
    loop: true,
    pagination: {
     el: '.swiper-pagination',
     clickable: true,
    },
    navigation: {
     nextEl: '.swiper-button-next',
     prevEl: '.swiper-button-prev',
    },
});

for (let i = 0; i < jQuery('.product-swiper').length; i++) {
    new Swiper('.product-section-' + i + ' .product-swiper', {
     modules: [Navigation, Pagination],
     slidesPerView: 5,
     slidesPerGroup: 1,
     spaceBetween: 30,
     autoHeight: true,
     navigation: {
        nextEl: '.swiper-button-next-' + i,
        prevEl: '.swiper-button-prev-' + i,
     },
     breakpoints: {
        0: {
         slidesPerView: 2, // Mobile
        },
        576: {
         slidesPerView: 2, // Small devices (e.g. portrait phones)
        },
        768: {
         slidesPerView: 3, // Tablets
        },
        992: {
         slidesPerView: 4, // Small laptops
        },
        1200: {
         slidesPerView: 5, // Large laptops and up
        },
     }
    });
}

const iso = new Isotope('#menuList', {
    itemSelector : '.product-item',
    layoutMode : 'vertical',
    filter     : '.appetizers'     // default cat
});

// delegate click from the nav container
jQuery('.product-cat-nav').on('click', 'button', function () {
    const filterValue = jQuery(this).data('filter');
    iso.arrange({ filter: filterValue });        // ← vanilla API

    // toggle active state
    jQuery('.product-cat-nav .filter-btn').removeClass('active');
    jQuery(this).addClass('active');
});


jQuery(document).ready(function ($) {
  function bindQtyButtons() {
    $('.quantity').off('click', '.plus, .minus');

    $('.quantity').on('click', '.plus', function () {
      const $qty = $(this).siblings('.qty');
      const currentVal = parseFloat($qty.val()) || 0;
      const max = parseFloat($qty.attr('max')) || Infinity;
      const step = parseFloat($qty.attr('step')) || 1;
      const newVal = currentVal + step > max ? max : currentVal + step;
      $qty.val(newVal).change();
      updateDataQty($qty, newVal);
    });

    $('.quantity').on('click', '.minus', function () {
      const $qty = $(this).siblings('.qty');
      const currentVal = parseFloat($qty.val()) || 0;
      const min = parseFloat($qty.attr('min')) || 1;
      const step = parseFloat($qty.attr('step')) || 1;
      const newVal = currentVal - step < min ? min : currentVal - step;
      $qty.val(newVal).change();
      updateDataQty($qty, newVal);
    });

    // Optional: Update on manual typing
    $('.quantity .qty').on('input', function () {
      const val = parseFloat($(this).val()) || 1;
      updateDataQty($(this), val);
    });
  }

  // Updates data-quantity on sibling .add_to_cart_button in archive/loop
  function updateDataQty($qtyInput, newVal) {
    const $container = $qtyInput.closest('.add-to-cart-container, form.cart');
    const $btn = $container.find('.add_to_cart_button');
    if ($btn.length) {
      $btn.attr('data-quantity', newVal);
    }
  }

  // Initialize bindings
  bindQtyButtons();

  // Re-bind after WooCommerce AJAX events (like cart update or fragments refresh)
  $(document.body).on('updated_cart_totals wc_fragments_refreshed', function () {
    bindQtyButtons();
  });
});

});

